import React from "react";
import "./title.css";

function Title() {
  return (
    <div className="text-center">
      <h1 className="text-2xl title">San Francisco</h1>
      <h1 className="title text-sm">BIRTHDAY FREEBIES!</h1>
    </div>
  );
}

export default Title;
